import api from "./api";

export const postImportedChartsService = async (jsonData: any) => {
    const response = await api.post(`influxDB/insertChartsPlants/`, jsonData);
    return response.data;
};
